module.exports = __webpack_public_path__ + "media/2.f93d369d.mp3";